'use client'

import { useTranslations } from 'next-intl'
import { FC, ReactNode, useState } from 'react'

import { authSignInBySocialService } from '@/services/auth-service'

import { GoogleLogo } from '../icon/google-logo'
import { Button } from '../ui/button'

interface AuthGoogleSignInProps {
  children?: ReactNode
  token?: string
  email?: string
}

const AuthGoogleSignIn: FC<AuthGoogleSignInProps> = ({ children, token, email }) => {
  const t = useTranslations('Auth')

  const [isLoading, setIsLoading] = useState(false)

  const handleLoginWithGoogle = async () => {
    setIsLoading(true)
    try {
      const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
      const callbackUrl = `${baseUrl}/auth/login/social`
      const newUserCallbackUrl = `${baseUrl}/user/update`
      const organizationOnboardingUrl = `${baseUrl}/auth/organization/onboarding/welcome?token=${token}&email=${encodeURIComponent(email ?? '')}`
      const isOnboarding = !!token || !!email

      await authSignInBySocialService({
        provider: 'google',
        newUserCallbackURL: isOnboarding ? organizationOnboardingUrl : newUserCallbackUrl,
        callbackURL: isOnboarding ? organizationOnboardingUrl : callbackUrl,
        requestSignUp: !isOnboarding,
        errorCallbackURL: isOnboarding
          ? `${baseUrl}/auth/organization/onboarding/sso?token=${token}&email=${encodeURIComponent(email ?? '')}`
          : window.location.href,
      })
    } catch (error) {
      console.error('Error with Google auth:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Button
        onClick={handleLoginWithGoogle}
        variant="outline"
        className="flex w-full items-center gap-2 py-2"
        disabled={isLoading}
      >
        {children || (
          <div className="flex w-full items-center justify-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center">
              <GoogleLogo />
            </div>
            {t('google.login')}
          </div>
        )}
      </Button>
    </>
  )
}

export default AuthGoogleSignIn
